import { createSlice } from '@reduxjs/toolkit';
import { reverse } from 'lodash';

const initialState = {};

export const notification = createSlice({
	name: 'notifications',
	initialState,
	reducers: {},
});

const URL = process.env.REACT_APP_PUSHER_LINK;

export const getNotifications = async ({ id, invoiceDate }) => {
	const query = {
		method: 'GET',
		headers: {
			'X-API-Key': process.env.REACT_APP_PUSHER_KEY,
		},
	};

	return fetch(`${URL}/replay?back_days=7&to=${id}`, query)
		.then((response) => response?.json())
		.then((res) => {
			let data = res?.data?.filter((item) => item?.body?.collection_date === invoiceDate);

			data = data.sort(
				(d1, d2) =>
					new Date(d1?.body?.createdAt).getTime() -
					new Date(d2?.body?.createdAt).getTime()
			);

			return reverse(data);
		});
};

export const putNotifications = (id) => {
	const query = {
		method: 'PUT',
		headers: {
			'X-API-Key': process.env.REACT_APP_PUSHER_KEY,
		},
	};

	return fetch(`${URL}/acknowledge/?notification-id=${id}`, query).then((response) =>
		response.json()
	);
};

export default notification.reducers;
